export default __webpack_public_path__ + "static/media/marauders-map-v5.2-gallery-07.2edabee2.jpg";